/** Value streams */
export const LINK_ORDER_TAKING = 'LINK_ORDER_TAKING'
export const LINK_POST_ORDER = 'LINK_POST_ORDER'
export const LINK_PLANNING = 'LINK_PLANNING'

/** Actions */
export const BUTTON_CLICKED = 'Button Clicked'
export const CONTENT_LOADED = 'Content Loaded'
export const SCROLL = 'Scroll'
export const PAGE_VIEWED = 'Page Viewed'

/** Screens */
export const HOMEPAGE = 'home'

/** Events Dispatch */
export const SET_BRANDS_BANNERS_VISIBILITY = 'SET_BRANDS_BANNERS_VISIBILITY'
